import { render, staticRenderFns } from "./MultipliersTable.vue?vue&type=template&id=53bbe4e7&"
import script from "./MultipliersTable.vue?vue&type=script&lang=js&"
export * from "./MultipliersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports